import { getFullPath, routes } from "../routes";
import { Navigate, useParams } from "react-router-dom";
import { useWelderProfile } from "./hooks";
import { WelderForm } from "./WelderForm";

export function EditWelder() {
  const { id } = useParams();
  const { data, isLoading, isError } = useWelderProfile(id);

  if (isLoading) {
    return <p>Loading...</p>;
  } else if (isError) {
    return <p>An unknown error occurred.</p>;
  } else if (data) {
    return <WelderForm data={data} />;
  } else {
    return <Navigate to={getFullPath(routes.welder.create)} />;
  }
}
